import type { PlumaFieldProps } from '@/components/form';
import type { SignupFormValues } from '../types';

type PatchFormValues = (patch: Partial<SignupFormValues>) => void;

/**
 * Wrap a `registerPluma` field so every keystroke writes through to the flow
 * state: steps unmount on navigation, so form-local values alone would be lost
 * on Back/Forward.
 */
export function withFlowWriteThrough(
  field: PlumaFieldProps<string>,
  name: keyof SignupFormValues,
  patchFormValues: PatchFormValues,
): PlumaFieldProps<string> {
  return {
    ...field,
    onInput: (event) => {
      field.onInput(event);
      patchFormValues({ [name]: event.target.value });
    },
  };
}
